import React from 'react';
import { Link } from 'react-router-dom';
import { NewNavbar, BreadCrumbsNew, NewFooter } from '../../components';
import NoIndexSeo from '../../components/NoIndexSeo';
import './notFound.css';

const BREADCRUMBS = [{ label: 'Home', path: '/' }, { label: 'Page Not Found' }];

function NotFoundPage() {
  return (
    <div className="nf-page">
      <NoIndexSeo title="Page Not Found" />
      <div className="breadcrumnb-img-bg">
        <div className="container">
          <NewNavbar />
          <BreadCrumbsNew breadcrumbs={BREADCRUMBS} title="Page Not Found" />
        </div>
      </div>

      <main className="nf-main">
        <span className="nf-code">404</span>
        <h2 className="nf-title">Sorry, we can't find that page</h2>
        <p className="nf-text">
          The page you are looking for may have been moved, renamed or is no longer available.
        </p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn">Back to Home</Link>
          <Link to="/contact" className="nf-btn nf-btn--secondary">Contact Us</Link>
        </div>
      </main>

      <NewFooter />
    </div>
  );
}

export default NotFoundPage;
